import React, { useState } from "react";
import axios from "axios";
import AppButton from "../../../components/common/appButton/AppButton";
import AppInput from "../../../components/common/appinput/AppInput";
import { ArrowLeft, ArrowRight, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../config/config";
import { message } from "antd";

const AdminPersonal = ({ }) => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [showConPassword, setShowConpassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
   const [data, setData] = useState({
      email: "",
      password: "",
      confirm_password: ""
    });
  
    
    const updateData = (data) => {
      setData((prev) => ({
        ...prev,
        ...data,
      }));
    };

    const handleSubmit = async () => {
      if (isLoading) return;

      setIsLoading(true);
      setErrors({});

      const payload = {
        email: data?.email?.trim() || "",
        password: data?.password || "",
        confirm_password: data?.confirm_password || "",
      };
      console.log(payload,"Payloaddd");
    

      try {
        const response = await axios.post(
          `${BASE_URL}/owner/register`,
          payload
        );

        console.log("owner register response:", response?.data);

        if (response?.data) {
          message.success("OTP Sent SuccessFully")
            navigate("/register/verify-otp", {
            state: {
              email: data?.email || "",
              role: "owner",
              from:"owner"
            },
          });
        }
      } catch (error) {
        console.log("Owner register error:", error);

        const apiMessage =
          error?.response?.data?.detail ||
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Unable to create your account. Please try again.";
          message.error(apiMessage)
        setErrors({
          submit: apiMessage,
        });
      } finally {
        setIsLoading(false);
      }
    }



  const handleValidation = () => {
    const newErrors = {};

    if (!data?.email?.trim()) {
      newErrors.email = "Email address is required";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)
    ) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!data?.password) {
      newErrors.password = "Password is required";
    } else if (data.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }

    if (!data?.confirm_password) {
      newErrors.confirm_password = "Please confirm your password";
    } else if (data?.password !== data?.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      handleSubmit()
    }
  };

  return (
    <main className="min-h-screen w-full overflow-hidden bg-[#fdfbf5] text-[#1f2318]">
      <section className="mx-auto flex min-h-screen w-full overflow-hidden bg-white lg:grid lg:grid-cols-[55.5%_44.5%]">

        <div className="relative hidden min-h-screen overflow-hidden lg:block">
          <img
            src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1600&q=85"
            alt="Modern UAE real estate property"
            className="absolute inset-0 h-full w-full object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-b from-[#1b2815]/10 via-[#172114]/20 to-[#172114]/80" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#172114]/20 via-transparent to-transparent" />

          <div className="absolute left-8 top-8 z-10 flex items-center gap-2 sm:left-10 sm:top-9">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-white/35 bg-white/15 text-white backdrop-blur-md">
              <Building2 size={15} strokeWidth={2.2} />
            </div>
            <span className="text-[14px] font-semibold tracking-[-0.01em] text-white">
              
            </span>
          </div>

          <div className="absolute right-8 top-8 z-10 rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-md sm:right-10 sm:top-9">
            UAE Real Estate
          </div>

          <div className="absolute bottom-7 left-8 right-8 z-10 sm:bottom-9 sm:left-10 sm:right-10 lg:bottom-10">
            <div className="mb-2 text-[9px] font-bold uppercase tracking-[0.17em] text-[#dce8cf] sm:text-[10px]">
              CREATE YOUR REAL ESTATE ACCOUNT
            </div>

            <h1 className="max-w-[650px] font-['Playfair_Display'] text-[38px] font-normal leading-[1.03]  text-white sm:text-[46px] lg:text-[48px]">
              Build your
              <br />
              <span className="italic font-medium tracking-[0.025em] text-[40px] text-[#ccc]">
                real estate journey.
              </span>
            </h1>

            <p className="mt-3 max-w-[470px] text-[11px] leading-[1.6] text-white/75 sm:text-[12px]">
              Create your account and get access to your UAE real estate
              experience from one simple Platform.
            </p>

            <div className="mt-6 grid max-w-[500px] grid-cols-[1fr_auto_1fr_auto_1fr] items-center rounded-[12px] border border-white/15 bg-[#171e23]/60 px-3 py-2.5 backdrop-blur-xl sm:px-4 sm:py-3">
              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">AED</strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">UAE currency</span>
              </div>
              <span className="h-7 w-px bg-white/15" />
              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">UAE</strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">Property market</span>
              </div>
              <span className="h-7 w-px bg-white/15" />
              <div className="text-center">
                <strong className="block text-[13px] font-semibold text-white">Digital</strong>
                <span className="mt-1 block text-[9px] uppercase tracking-[0.08em] text-white/50">Account access</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT — SIGNUP CONTENT */}
        <div className="relative flex min-h-screen w-full items-center justify-center bg-white px-6 py-12 sm:px-10 lg:px-12 xl:px-16">
          {/* Back button stays at the top-left of the right panel */}
          <button
            type="button"
            onClick={()=>navigate(-1)}
            aria-label="Go back"
            className="absolute left-6 top-6 inline-flex items-center gap-2 rounded-full border border-[#e2e7de] bg-white px-3.5 py-2 text-[11px] font-semibold text-[#6f7468] shadow-[0_5px_18px_rgba(55,92,32,0.06)] transition hover:-translate-y-px hover:border-[#cddcbd] hover:bg-[#f7f9f4] hover:text-[#4c7a2e] sm:left-10 sm:top-8 lg:left-12"
          >
            <ArrowLeft size={14} />
            Back
          </button>

          <div className="w-full max-w-[500px] pt-10 sm:pt-7 mt-10">
            <div className="mb-2 inline-flex rounded-full border border-[#cddcbd] bg-[#f0f6ea] px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.14em] text-[#4c7a2e]">
             Property Owner Account
            </div>

          
            <div className="mt-5">
                <div className="w-full">
      {/* Section heading */}
      <div className="mb-1 text-[9px] font-bold uppercase tracking-[0.14em] text-[#6a7847]">
        Personal information
      </div>

      <h1 className="font-['Playfair_Display'] text-[29px] font-normal leading-[1.05] tracking-[-0.02em] text-[#183240] sm:text-[31px]">
        Join as an Property Owner{" "}
        <span className="italic font-medium text-[#4c7a2e]">
          
        </span>
      </h1>

      <p className="mt-2 text-[11px] leading-[1.55] text-[#899087]">
        Tell us a little about yourself
      </p>

      <div className="mt-5 space-y-4">
        <AppInput
          label="Email Address"
          required
          type="email"
          name="email"
          value={data?.email || ""}
          onChange={(e) => {
            updateData({ email: e.target.value });

            if (errors.email) {
              setErrors((prev) => ({
                ...prev,
                email: "",
              }));
            }
          }}
          placeholder="you@example.com"
          error={errors.email}
        />

        <AppInput
          label="Password"
          required
          type="password"
          name="password"
          value={data?.password || ""}
          onChange={(e) => {
            updateData({ password: e.target.value });

            if (errors.password) {
              setErrors((prev) => ({
                ...prev,
                password: "",
              }));
            }
          }}
          placeholder="Min. 8 characters"
          showPasswordToggle
          showPassword={showPassword}
          onTogglePassword={() =>
            setShowPassword((prev) => !prev)
          }
          error={errors.password}
        />

        <AppInput
          label="Confirm Password"
          required
          type="password"
          name="confirm_password"
          value={data?.confirm_password || ""}
          onChange={(e) => {
            updateData({ confirm_password: e.target.value });

            if (errors?.confirm_password) {
              setErrors((prev) => ({
                ...prev,
                confirm_password: "",
              }));
            }
          }}
          placeholder="Repeat your password"
          showPasswordToggle
          showPassword={showConPassword}
          onTogglePassword={() =>
            setShowConpassword((prev) => !prev)
          }
          error={errors.confirm_password}
        />
      </div>

      {errors?.submit && (
        <div className="mt-4 rounded-[10px] border border-red-200 bg-red-50 px-3 py-2.5 text-[11px] leading-[1.5] text-red-600">
          {errors.submit}
        </div>
      )}

      <div className="mt-5">
        <AppButton
          type="button"
          onClick={handleValidation}
          disabled={isLoading}
        >
          {isLoading ? "Creating Account..." : "Submit"}
          {!isLoading && <span aria-hidden="true"></span>}
        </AppButton>
      </div>
    </div>
            </div>

            <div className="mt-5 flex items-center justify-center text-[11px] text-[#92968e]">
              Already have an account?
              <button
                type="button"
                onClick={()=>navigate("/login")}
                className="ml-1 border-none bg-transparent p-0 font-semibold text-[#4c7a2e] hover:underline"
              >
                Sign in
                <ArrowRight size={11} className="ml-1 inline-block" />
              </button>
            </div>
          </div>
        </div>
  
      </section>
    </main>
  );
};

export default AdminPersonal;

